import {
  DOCUMENT_TYPES,
  ARTICLE_DATA_TYPES,
  HUB_DATA_TYPES,
  PERSON_DATA_TYPES,
  NAVIGATION_DATA_TYPES,
  MODAL_DATA_TYPES
} from './customPropTypes';

export const DOCUMENT_TYPE_TO_DATA_TYPES = {
  [DOCUMENT_TYPES.ARTICLE]: ARTICLE_DATA_TYPES,
  [DOCUMENT_TYPES.HUB]: HUB_DATA_TYPES,
  [DOCUMENT_TYPES.PERSON]: PERSON_DATA_TYPES,
  [DOCUMENT_TYPES.NAVIGATION]: NAVIGATION_DATA_TYPES,
  [DOCUMENT_TYPES.MODAL]: MODAL_DATA_TYPES
};
